import styled from 'styled-components';

export const LastFetchedStyle = styled.div`
  .lastFetchedDiv {
    width: 100%;
    height: 100%;
    margin-top: 0;
    margin-left: 8%;
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .spacer {
    visibility: hidden;
    height: 15px;
    line-height: 15px;
    margin: 0 0 4px 0;
  }
  .lastFetchedRow {
    display: flex;
    align-items: center;
    white-space: nowrap;
    min-height: 35px;
  }
  .heading {
    margin-top: 0;
    margin-bottom: 0;
    font-size: 13px;
    font-weight: 700;
    line-height: 18px;
    color: #888888;
  }
  .time {
    margin-top: 0;
    margin-bottom: 0;
    margin-left: 5px;
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    color: #888888;
    font-family: 'lg-smart', sans-serif;
  }
  .refreshIcon {
    flex: 0 0 auto;
    margin-top: 0;
    margin-left: 6px;
    font-size: 20px;
    color: #006e7d;
    background-color: #d2e4e7;
    padding: 4px;
    border-radius: 50%;
    cursor: pointer;
  }
  .spinner {
    margin-left: 8px;
    font-size: 13px;
  }
`;
